import React from 'react';
import ReactDOM from 'react-dom/client';
import { KaveriAppStore, TivoProvider } from './core/tivo/tivo-redux-wrapper';
import { App } from './views';
import reportWebVitals from './reportWebVitals';

import './index.scss';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
    <React.StrictMode>
        <TivoProvider store={KaveriAppStore}>
            <App />
        </TivoProvider>
    </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
